import validate from "/var/www/frontend/reviewapp-production/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45404_45global from "/var/www/frontend/reviewapp-production/middleware/redirect-404.global.ts";
import manifest_45route_45rule from "/var/www/frontend/reviewapp-production/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45404_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/frontend/reviewapp-production/middleware/auth.ts")
}